export  const formatCurrency = (x: number) => {
    return x ? x.toFixed(0).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".") : "0";
}